const Perfiles = () => <div><h3>🗂️ Gestión de Perfiles</h3></div>;
export default Perfiles;